<template>
    <div class="videoList">
        <ul>
            <Li v-for="(item,index) in dataList" :key="index" class="hoverLi">
                <div class="item">
                    <div class="imgBox">
                        <a :href="item.link">
                            <el-image style="width: 100%;height: 100%" fit="cover"
                                    :src="item.cover">
                                <div slot="placeholder" class="image-slot">
                                    加载中<span class="dot">...</span>
                                </div>
                                <div slot="error" class="el-image__error">
                                    <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                </div>
                            </el-image>
                            <span class="vIcon"></span>
                        </a>

                    </div>
                    <div class="infoBox">
                        <a :href="item.link" class="auctionFont fontLine lineText twoLineText">{{item.title}}</a>
                        <span class="time verdanF12 color999">{{item.publish_at}}</span>
                        <div class="detail fontSong12 color666 lineText fourLineText">
                            {{ item.desc }}
                        </div>
                    </div>
                </div>
            </Li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "videoList",
    props:["dataList"],
}
</script>

<style scoped lang="scss">
@import "@/assets/css/auctionCompany.scss";
.videoList{
    ul{
        li{
            padding: 30px 19px;
            //border-bottom: 1px solid #f2f2f2;
            //&:last-child{
            //    border-bottom: none;
            //}
            &:hover{
                .item{
                    .imgBox{
                        .vIcon{
                            background-position: left -30px;
                        }
                    }
                }
            }
            .item{
                display: inline-flex;
                justify-content: flex-start;
                .imgBox{
                    display: block;
                    width: 200px;
                    height: 109px;
                    overflow: hidden;
                    position: relative;
                    .vIcon{
                        display: block;
                        width: 20px;
                        height: 20px;
                        position: absolute;
                        left: 10px;
                        bottom: 9px;
                        background: url(../../../../assets/imgs/old/vIconCom.png) no-repeat;
                        background-position: left top;
                    }
                }
            }
            .infoBox{
                margin-left: 10px;
                width: 430px;
                margin-top: 3px;
                .title{
                    width: 100%;
                    display: block;
                }
                .time{
                    display: block;
                    margin-top: 2px;
                }
                .detail{
                    margin-top: 15px;
                    line-height: 20px;
                    text-align: justify;
                }
            }
        }
    }
}
</style>